import React from 'react';
import PropTypes from 'prop-types';
import { MODE_TIME } from './Constants';

function SwitchButton({ onSwitch, mode }) {
  return mode === MODE_TIME ? (
    <ul className="list-unstyled">
      <li>
        <span
          className="btn picker-switch"
          onClick={onSwitch}
          style={{ width: '100%' }}
        >
          <span className="glyphicon glyphicon-time" />
        </span>
      </li>
    </ul>
  ) : null;
}

function DateTimePickerMinutes({ setSelectedMinute, onSwitch, mode }) {
  return (
    <div
      className="timepicker-minutes"
      data-action="selectMinute"
      style={{ display: 'block' }}
    >
      <SwitchButton onSwitch={onSwitch} mode={mode} />
      <table className="table-condensed">
        <tbody>
          <tr>
            <td className="minute" onClick={setSelectedMinute}>
              00
            </td>

            <td className="minute" onClick={setSelectedMinute}>
              05
            </td>

            <td className="minute" onClick={setSelectedMinute}>
              10
            </td>

            <td className="minute" onClick={setSelectedMinute}>
              15
            </td>
          </tr>

          <tr>
            <td className="minute" onClick={setSelectedMinute}>
              20
            </td>

            <td className="minute" onClick={setSelectedMinute}>
              25
            </td>

            <td className="minute" onClick={setSelectedMinute}>
              30
            </td>

            <td className="minute" onClick={setSelectedMinute}>
              35
            </td>
          </tr>

          <tr>
            <td className="minute" onClick={setSelectedMinute}>
              40
            </td>

            <td className="minute" onClick={setSelectedMinute}>
              45
            </td>

            <td className="minute" onClick={setSelectedMinute}>
              50
            </td>

            <td className="minute" onClick={setSelectedMinute}>
              55
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

DateTimePickerMinutes.propTypes = {
  setSelectedMinute: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
};

export default DateTimePickerMinutes;
